/// <amd-module name="CodeCoverage/Common/Actions/CodeCoverageActionHub" />
import { Action } from "VSS/Reflux/Action";
import { ICodeCoverageTimelineSummaryData } from "CodeCoverage/Common/Interfaces/ICodeCoverageTimelineSummaryData";

export class CodeCoverageActionHub {
    public initializeCodeCodeCoverageSummary = new Action<CodeCoverageSummaryData>();
}

export class CodeCoverageSummaryData {
    timelineSummaryData: ICodeCoverageTimelineSummaryData[];
}
